/**
 * Test IDs for QA automation.
 */
export const testIds = {
  viewUserDetails: "view-user-details",
} as const;
